 

let config={
   serverUrl: "https://api.checkyourprono.com/tpro", // use Ip address instead of localhost
  port:80 // incase of running api-server (node app) in development
 
};
export default(config)
